import { ISuggestResponse } from '../repositories/newbuilding-promos/entities/suggest/SuggestResponse';
import { ESuggestionType, ISuggestionItem } from '../types/suggestions';

export const prepareSuggestions = (response: ISuggestResponse): ISuggestionItem[] => {
  const suggestions = response.suggestions;

  return suggestions.map(suggestion => {
    return {
      ...suggestion,
      type: suggestion.type as unknown as ESuggestionType,
    };
  });
};
